/**
 * page-header.tsx - Cabecalho unico de toda tela do app.
 *
 * Elimina as 24 reimplementacoes divergentes: eyebrow IBM Plex Mono
 * 0.625rem uppercase; h1 Space Grotesk 1.375rem/600 (UM tamanho so);
 * descricao opcional; actions e um slot a direita para botoes.
 */

import type { ReactNode } from "react";

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "1rem",
        flexWrap: "wrap",
        marginBottom: "1.5rem",
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontFamily: '"IBM Plex Mono", monospace',
            fontSize: "0.625rem",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: "var(--color-text-muted)",
          }}
        >
          {eyebrow}
        </div>
        <h1
          style={{
            fontFamily: '"Space Grotesk", sans-serif',
            fontSize: "1.375rem",
            fontWeight: 600,
            color: "var(--color-text-primary)",
            margin: "0.25rem 0 0",
          }}
        >
          {title}
        </h1>
        {description != null && (
          <p
            style={{
              fontFamily: '"Inter", sans-serif',
              fontSize: "0.875rem",
              lineHeight: 1.6,
              color: "var(--color-text-secondary)",
              margin: "0.375rem 0 0",
              maxWidth: "62ch",
            }}
          >
            {description}
          </p>
        )}
      </div>
      {actions != null && (
        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", flexWrap: "wrap" }}>
          {actions}
        </div>
      )}
    </header>
  );
}
